import {
  validateAccountId,
  validateBtcAddress,
  validateEthAddress,
  validatePrincipal,
  validateSolAddress,
} from '../utils/validationHelper'
import { fetchEnv } from './fetchEnv'

export enum AddressType {
  AccountId,
  PrincipalId,
  Invalid,
  Eth,
  Sol,
  Btc,
}

export const isCaseSensitiveAddress = (address: string) => {
  const type = addressMatcher(address)

  return (
    type === AddressType.AccountId || type === AddressType.PrincipalId || type === AddressType.Eth
  )
}

const addressMatcher = (address: string) => {
  if (!address) return AddressType.Invalid

  if (validateAccountId(address)) return AddressType.AccountId
  if (validatePrincipal(address)) return AddressType.PrincipalId
  if (validateEthAddress(address)) return AddressType.Eth
  if (validateSolAddress(address)) return AddressType.Sol
  if (validateBtcAddress(address)) return AddressType.Btc

  if (fetchEnv('VITE_BITCOIN_CHAIN') === 'testnet' && address.startsWith('tb1'))
    return AddressType.Btc

  return AddressType.Invalid
}

export default addressMatcher
